import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";

export interface IPrediction {
	contestId: number;
	playerId: number;
}

export type TPredictionResponse = IApiResponse<{prediction: IPrediction}>;
export type TPredictionsResponse = IApiResponse<{predictions: IPrediction[]}>;

export interface IPredictionApiProvider {
	save: (params: IPrediction) => Promise<AxiosResponse<TPredictionResponse>>;
	get: (contestId: number) => Promise<AxiosResponse<TPredictionResponse>>;
	predictions: () => Promise<AxiosResponse<TPredictionsResponse>>;
}

@injectable()
export class PredictionApiProvider implements IPredictionApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	save = (params: IPrediction) => this._http.post<TPredictionResponse>("pog/prediction", params);

	get = (contestId: number) => this._http.get<TPredictionResponse>(`pog/prediction/${contestId}`);

	predictions = () => this._http.get<TPredictionsResponse>(`pog/predictions`);
}
